import { render, staticRenderFns } from "./DisplayColumnsComponent.vue?vue&type=template&id=c46bba42&scoped=true"
import script from "./DisplayColumnsComponent.vue?vue&type=script&lang=js"
export * from "./DisplayColumnsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46bba42",
  null
  
)

export default component.exports